/**
 * Globale Variablen für die Anwendung
 * MangaShelf API v1.2
 */

// ============================================================================
// API CONFIGURATION
// ============================================================================

// API Base URL - /api/v1
// Im Production-Build (Docker/nginx) wird /api/v1 über den nginx-Proxy weitergeleitet
// → kein CORS, da Browser nur die eigene Domain sieht
// Development: direkte URL (benötigt CORS im Backend oder separaten Proxy)
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/v1';

// Media Base URL (für Bilder/Covers) - optional, falls CDN verwendet wird
// Falls nicht gesetzt, wird API_BASE_URL/media/{key} verwendet
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL || null;

// ============================================================================
// APP INFO
// ============================================================================

export const APP_NAME = "MangaShelf";
export const VERSION = "2.0.0";

// ============================================================================
// API DEFAULTS
// ============================================================================

// Cursor-Pagination Defaults
export const DEFAULT_PAGE_LIMIT = 200;
export const MAX_PAGE_LIMIT = 1000;

// ============================================================================
// USER ROLES
// ============================================================================

export const UserRoles = {
  ADMIN: 0,
  MODERATOR: 1,
  RESERVED: 2,
  SUBSCRIBER: 3,
  USER: 4,
  GUEST: 5,
};

export const RoleNames = {
  [UserRoles.ADMIN]: 'Admin',
  [UserRoles.MODERATOR]: 'Moderator',
  [UserRoles.RESERVED]: 'Reserved',
  [UserRoles.SUBSCRIBER]: 'Subscriber',
  [UserRoles.USER]: 'User',
  [UserRoles.GUEST]: 'Guest',
};

// ============================================================================
// READING STATUS
// ============================================================================

export const ReadingStatus = {
  READ: 'READ',
  UNREAD: 'UNREAD',
};

// ============================================================================
// MANGA STATUS
// ============================================================================

export const MangaStatus = {
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  HIATUS: 'HIATUS',
  CANCELLED: 'CANCELLED',
};

// ============================================================================
// DEBUG LOGGING
// ============================================================================

if (process.env.NODE_ENV === 'development') {
}